import { render, staticRenderFns } from "./FooterPayments.vue?vue&type=template&id=745f0ac4&"
import script from "./FooterPayments.vue?vue&type=script&lang=js&"
export * from "./FooterPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports